import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SignupStatusChip from './SignupStatusChip';
import { formatDate } from '../../../../utils/Utils';

/**
 * Formata uma data 'Y-m-d H:i:s' (fuso do servidor) usando formatDate() do projeto.
 * @param {string|null} dateStr
 * @returns {string}
 */
function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * Formata telefone + DDI, quando presentes.
 * @param {string|null} countryCode
 * @param {string|null} phone
 * @returns {string}
 */
function formatPhone(countryCode, phone) {
  if (!phone) return '—';
  return countryCode ? `+${countryCode} ${phone}` : phone;
}

/**
 * SignupRow - Linha da tabela de cadastros pendentes (Admin Geral > Cadastros pendentes)
 * @param {Object} props
 * @param {Object} props.signup
 * @param {Function} props.onResend
 * @param {boolean} props.isResending
 */
function SignupRow({ signup, onResend, isResending }) {
  const {
    name,
    email,
    company_name: companyName,
    phone,
    country_code: countryCode,
    created_at: createdAt,
    email_sent_at: emailSentAt,
    resend_count: resendCount,
    token_expires_at: tokenExpiresAt,
    status,
  } = signup;

  const isConfirmed = status === 'confirmed';

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>{name || '—'}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" color="text.secondary">{email}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{companyName || '—'}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{formatPhone(countryCode, phone)}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{fmtDate(createdAt)}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{fmtDate(emailSentAt)}</Typography>
        {resendCount > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {resendCount} reenvio{resendCount > 1 ? 's' : ''}
          </Typography>
        )}
      </TableCell>

      <TableCell>
        <Typography variant="body2">{fmtDate(tokenExpiresAt)}</Typography>
        <Box sx={{ mt: 0.5 }}>
          <SignupStatusChip status={status} />
        </Box>
      </TableCell>

      <TableCell align="right">
        <Button
          size="small"
          variant="outlined"
          startIcon={isResending ? <CircularProgress size={14} /> : <SendOutlinedIcon fontSize="small" />}
          onClick={() => onResend(signup)}
          disabled={isConfirmed || isResending}
        >
          Reenviar
        </Button>
      </TableCell>
    </TableRow>
  );
}

export default SignupRow;
